/**
 * @author wuTao
 * @description 资源直播列表
 * @Date 2022/04/19
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'
import { resourcesLiveExcelColumns,liveRecordDetailExcelColumns } from '../excelColumns';
import { framework_tool,utils_tool ,component_tool} from '@/tool'
import moment from "moment";
let { WizContainer, WizReduxTemplate } = framework_tool;
let {checkStrLength, Session} = utils_tool;
let {  WizBrowserExport } = component_tool;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYYMMDDHHmm') : '';
}
const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/interactLiveResources/liveList') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('interactLiveResources', record)
      } else {
        record = Session.get('interactLiveResources') || 0
      }
    }
  } else {
    record = Session.get('interactLiveResources') || 0
  }
  return record
}
class ResourcesLiveList extends WizContainer {

  componentName = 'resourcesLiveList';

  constructor(props) {
    super(props);
    this.state = {
      resourcesListKey: new Date().getTime(),
    }
    this.initialValue = getParamRecord(props.history);
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = resourcesLiveExcelColumns;
    if (o['success']) {
      let data = o['data']
      let _data = []
      data && data.dataList && data.dataList.forEach(d => {
        let _d = { ...d }
        let authData = d['authInfo']
        let target = ''
        if (authData && Object.keys(authData)) {
          if (authData['orgIds'] && authData['orgIds'].length) {
            target += ' 组织范围：'
            authData['orgIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionIds'] && authData['positionIds'].length) {
            target += ' 岗位：'
            authData['positionIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
            target += ' 岗位分类：'
            authData['positionCategoryIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['personIds'] && authData['personIds'].length) {
            target += ' 指定人员：'
            authData['personIds'].forEach(org => {
              target += org['userName'] +'('+org['fullName'] +'),'
            });
            target += '\n'
          }
        }
        _d['scope'] = target
        _data.push(_d)
      });
      let dateTime = formatterDate(new Date());
      WizBrowserExport({
        title: '直播信息',
        sheetName: '直播信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '直播信息-'+dateTime+'.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleLiveRecordDetailFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = liveRecordDetailExcelColumns;
    if (o['success']) {
      let data = o['data']
      let _data = []
      data && data.forEach(d => {
        let _d = { ...d }
        _data.push(_d)
      });
      let dateTime = formatterDate(new Date());
      WizBrowserExport({
        title: '直播参训明细信息',
        sheetName: '直播参训明细信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '直播参训明细信息-'+dateTime+'.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _render() {
    let initialValue = this.initialValue;
    const {id, userEmail} = initialValue;
    let _templateConfig = templateConfig({userEmail})
    let _reduxTemplateCofig = reduxTemplateCofig({
      interactLiveResourcesId: id,
      templateConfig:_templateConfig,
      apiDataFormat: {
        export:this._handleFile,
        exportLiveRecordDetail:this._handleLiveRecordDetailFile,
      },

    })
    return <WizReduxTemplate {..._reduxTemplateCofig} key={id+'_'+this.state.resourcesListKey} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ResourcesLiveList);
